module.exports = __webpack_public_path__ + "img/6.10444ff4.png";